export const formatDate = (isoDate) => {
  if (!isoDate) {
    return "";
  }

  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export const capitalizeFirstLetter = (value = "") => {
  const string = typeof value === "string" ? value : String(value ?? "");
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
}
